import { atom } from 'jotai'
import { TodoList } from 'javascripts/api/generated/api'

export type TodoListStatus = 'idle' | 'loading' | 'loaded' | 'error'

export type TodoListAtomState = {
  status: TodoListStatus
  todoList: TodoList | null
}

// 案件への応募が完了した際に、ヘッダーの「登録後にやることリスト」を再取得させるためのイベント名
// NOTE: 応募処理とヘッダーはVite上で別バンドルになりうるため、jotaiのatomを直接共有せず
// windowのカスタムイベントで疎結合に連携する
export const TODO_LIST_REFRESH_EVENT = 'todo-list:refresh'

// Headerがページ遷移のたびに再マウントされても、やることリストを何度もAPIから取得しないよう
// jotaiのatomで取得状態ごとキャッシュして共有する
export const todoListAtom = atom<TodoListAtomState>({ status: 'idle', todoList: null })
